import FilterInTable from "../../../../Manage/FilterInTable"
import SellerActionDropdown from "../../../../../components/common/SellerCommonComponents/SellerActionDropdown/SellerActionDropdown"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"

const Deactivated = () => {

  const actions = [
    { label: 'View' },
    { label: 'Edit' },
    { label: 'Delete' },
  ]

  const data = [
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Deactivated",
    },
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Deactivated",
    },
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Deactivated",
    },
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Deactivated",
    },
    {
      couponCode: "COUPON10",
      couponType: "Percentage off",
      validityPeriod: "30 March - 7 April",
      discount: "20%",
      conditions: ["Min.spent: 20$", "1 per customer"],
      applicability: "Electronics",
      used: " 20 / 100",
      status: "Deactivated",
    },
  ]

  const columns = [
    {
      name: "Coupon Code",
      selector: (row) => row.couponCode,
      wrap: true
    },
    {
      name: "Coupon type",
      selector: (row) => row.couponType,
      wrap: true
    },
    {
      name: "Validity Period",
      selector: (row) => row.validityPeriod,
      wrap: true
    },
    {
      name: "Discount",
      selector: (row) => row.discount,
      wrap: true
    },
    {
      name: "Conditions",
      cell: (row) => (
        <div>
          {row.conditions.map((item) => (
            <div>{item}</div>
          ))}
        </div>
      ),
      wrap: true
    },
    {
      name: "Applicability",
      selector: (row) => row.applicability,
      wrap: true
    },
    {
      name: "Used",
      selector: (row) => row.used,
      wrap: true
    },
    {
      name: "Status",
      selector: (row) => {
        let color
        switch (row.status) {
          case "Active":
            color = "#41B8E4"
            break
          case "Deactivated":
            color = "#EC7426"
            break
          case "Ended":
            color = "black"
            break
          default:
            color = "black"
            break
        }
        return <span style={{ color: color }}>{row.status}</span>
      },
      wrap: true
    },
    {
      name: "Action",
      cell: () => {
        return <SellerActionDropdown options={actions} />
      },
      wrap: true
    },
  ]

  return (
    <div className="p-3 bg-white">
      <FilterInTable componentName="Coupons All" />
      <div className="mt-3">
        <DatatableComponent data={data} columns={columns} type='gray' />
      </div>
    </div>
  )
}

export default Deactivated
